import { Badge } from '@fluentui/react-components';
import type { Row, Table } from '@tanstack/react-table';
import { useStyles } from './styles.js';

type DataTableToolbarCountProps<TData> = {
    table: Table<TData>;
    generateCustomCounts?: (data: Row<TData>[]) => { label: string; count: number }[];
};

export function DataTableToolbarCount<TData>({ table, generateCustomCounts }: DataTableToolbarCountProps<TData>) {
    const styles = useStyles();

    const rows = table.getRowModel().rows;

    const counts = generateCustomCounts
        ? generateCustomCounts(rows)
        : [
              {
                  label: 'Einträge',
                  count: rows.length,
              },
          ];

    return counts.map(({ label, count }, index) => (
        <Badge key={index} className={styles.badge} appearance="outline" size="large">
            {label}: {count}
        </Badge>
    ));
}
